import React from 'react';
import { Route, withRouter } from 'react-router';
import VinWiseOpeningList from "./components/vinWiseOpeningList";
import VinWiseOpeningForm from "./components/vinWiseOpeningForm";

const VinWiseOpening = () => {
    return (
        <>
            <Route path="/vin_wise_opp/list" component={withRouter(VinWiseOpeningList)} />
            <Route path="/vin_wise_opp/edit/:id" component={VinWiseOpeningForm} />
            <Route path="/vin_wise_opp/create" component={VinWiseOpeningForm} />
        </>
    )
};

export default VinWiseOpening;